export const getSessionStorageItem = (key) => {
    try {
        return window.sessionStorage.getItem(key);
    }
    catch (_) {
        return null;
    }
};
export const setSessionStorageItem = (key, value) => {
    try {
        window.sessionStorage.setItem(key, value);
        return true;
    }
    catch (_) {
        return false;
    }
};
//# sourceMappingURL=session.js.map